import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import Select from "components/Form/Select";
import {Checkbox} from "components/Form/SpecialButtons";

const GeneralForm = ({errors, centers, values}) => {
	return (
	<div>
		<Field
			type='text'
			name='name'
			customlabel='Nom'
			component={CustomInputTextComponent}
			required
		/>
			<Field
			type='text'
			name='abbreviation'
			customlabel='Code'
			component={CustomInputTextComponent}
			required
		/>
	 <Field
            component={Select}
            name="center"
            customlabel="Centre"
            placeholder='Sélectionner un centre'
            options={centers ? centers.map(c => {return {value : c.id, label: c.name}}).sort((a, b) => a.label.localeCompare(b.label)) : []} 
            errors={errors}
        />
	 {values.center && <Field
			id='reassign'
			name='reassign'
			customlabel='Réassigner tous les documents scannés avec ce scanner à ce centre'
			component={Checkbox}
			required
		/>}

	</div>)
};

export default GeneralForm;
